import { render, staticRenderFns } from "./EntityMapping.vue?vue&type=template&id=2023c3fa&scoped=true"
import script from "./EntityMapping.vue?vue&type=script&lang=js"
export * from "./EntityMapping.vue?vue&type=script&lang=js"
import style0 from "./EntityMapping.vue?vue&type=style&index=0&id=2023c3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2023c3fa",
  null
  
)

export default component.exports